import { authApi } from '@shared/services/api/authApi';
import { AppError } from '@shared/services/api/AppError';
import type { DirectorySession } from '../types/auth.types';

/**
 * Sesión de producto (User Directory).
 * Requiere JWT Auth0; no exige manage:users.
 */
export const getDirectoryMe = async (): Promise<DirectorySession> => {
  try {
    const response = await authApi.get<DirectorySession>('/me');
    const data = response.data;
    return {
      ...data,
      permissions: data.permissions ?? data.scopes ?? [],
      roles: data.roles ?? [],
      municipalities: data.municipalities ?? [],
    };
  } catch (error) {
    if (error instanceof AppError) {
      const code =
        typeof error.details?.error === 'string' ? error.details.error : undefined;
      if (error.status === 404 || code === 'user_not_found') {
        throw new AppError(
          'Tu cuenta no está registrada en el directorio de usuarios (erlia-auth).',
          error.status,
          error.details
        );
      }
      if (error.status === 401 || code === 'unauthorized') {
        throw new AppError(
          'Sesión no autorizada para el directorio de usuarios.',
          error.status,
          error.details
        );
      }
    }
    throw error;
  }
};
